module.exports = "/static/assets/5aeeafc514f8643a6ac06aaa54e31043.png";